export const validateInput = (input: string, maxLength = 1000): boolean => {
  if (!input || typeof input !== 'string') return false;
  if (input.length === 0 || input.length > maxLength) return false;
  // Prevent HTML/script injection
  if (/<[^>]*>/.test(input)) return false;
  return true;
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePassword = (password: string): boolean => {
  // At least 8 characters, 1 uppercase, 1 lowercase, 1 number
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
  return passwordRegex.test(password);
};